import { render } from "./Loginnew.vue?vue&type=template&id=62e765b4&scoped=true"
import script from "./Loginnew.vue?vue&type=script&lang=js"
export * from "./Loginnew.vue?vue&type=script&lang=js"

import "./Loginnew.vue?vue&type=style&index=0&id=62e765b4&scoped=true&lang=css"

import exportComponent from "/Volumes/work/mywork/selecthouse/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62e765b4"]])

export default __exports__